<template>
    <div class="clients-list p-3">
        <h2 class="mb-1">Liste des commandes</h2>
        <div class="header-card d-flex justify-content-between align-items-center mb-3 p-3 rounded shadow-sm">
            <div class="row">
                <div class="col-sm-9">
                    <small class="text-muted">Total : {{ orders.length }} commandes</small>
                    <div class="row">
                        <div class="col">
                            <span :class="'badge ' + statusInfo['approved'].class + ' ms-1 '" role="button"
                                @click="filterByStatus('approved')">
                                {{orders.filter(o => o.status === 'approved').length}} en cours
                                <i class="bi bi-bullseye ms-1" v-if="filter == 'approved'"></i>
                            </span>


                            <span :class="'badge ' + statusInfo['done'].class + ' ms-1 '" role="button"
                                @click="filterByStatus('done')">
                                {{orders.filter(o => o.status === 'done').length}} terminées
                                <i class="bi bi-bullseye ms-1" v-if="filter == 'done'"></i>

                            </span>

                            <span :class="'badge ' + statusInfo['delivered'].class + ' ms-1 '" role="button"
                                @click="filterByStatus('delivered')">
                                {{orders.filter(o => o.status === 'delivered').length}} livrées
                                <i class="bi bi-bullseye ms-1" v-if="filter == 'delivered'"></i>

                            </span>
                            <span :class="'badge ' + statusInfo['rejected'].class + ' ms-1 '" role="button"
                                @click="filterByStatus('rejected')">
                                {{orders.filter(o => o.status === 'rejected').length}} annulées
                                <i class="bi bi-bullseye ms-1" v-if="filter == 'rejected'"></i>
                            </span>
                            <span :class="'badge ' + statusInfo['pending'].class + ' ms-1 '" role="button"
                                @click="filterByStatus('pending')">
                                {{orders.filter(o => o.status === 'pending').length}} en attente
                                <i class="bi bi-bullseye ms-1" v-if="filter == 'pending'"></i>

                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <button class="btn btn-purple px-4 d-none" @click="$router.push({ name: 'clients.create' })">
                    <i class="bi bi-person-plus me-1"></i>Ajouter
                </button>
            </div>
        </div>

        <div class="card p-3 mb-3">
            <h5>Prochains rendez-vous</h5>
            <div class="row">
                <div :class="'col border border-purple rounded ' + (idx%2 == 0 ? 'mx-1' : '')" v-for="(rdv, idx) in rdvCountsToPrint" :key="idx+'rdv_count'">
                    <span class="d-none d-md-block">{{ rdv.dayName }}</span>
                    <span class="d-block d-md-none">{{ rdv.shortDayName }}</span>
                    <div class="text-end">{{ rdv.count }}</div>
                </div>

            </div>
        </div>

    </div>

    <div class="p-1 bg-white rounded shadow-sm mt-2">
        <div class="row mb-3">
            <div class="col-md-6 col-12">
                <input type="text" class="form-control" placeholder="Recherche (nom, prénom, libellé)"
                    v-model="search" />
            </div>
        </div>
        <div v-if="clientsToPrint.length > 0">

            <div class="d-none d-md-block table-responsive">
                <table class="table table-hover table-striped align-middle clients-table">
                    <thead class="table-purple text-white">
                        <tr>
                            <th>#</th>
                            <th>Libellé</th>
                            <th>status</th>
                            <th>Jours avant rdv</th>
                            <th>Date livraison</th>
                            <th>Client</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(o, idx) in clientsToPrint" :key="o.id" class="table-row-hover">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ o.label || '—' }}</td>
                            <td> <span :class="'badge ' + statusInfo[o.status]?.class">
                                    {{ statusInfo[o.status]?.label || '—' }}
                                </span></td>
                            <td>{{ o.status!='pending' ? dateFormater.formatDate(o.next_rdv) + ' - ' + daysUntil(o.next_rdv) : 'En attente de validation' }}</td>
                            <td>{{ dateFormater.formatDate(o.delivery_date) || '—' }}</td>
                            <td>
                                <div>{{ (o.client.nom + (' ' + o.client.prenoms) || null) || '—' }}</div>
                                <small class="text-muted">{{ o.client.telephone || '—' }}</small>
                            </td>
                            <td>
                                <button class="btn btn-sm btn-outline-purple me-1"
                                    @click="$router.push({ name: 'models.view', params: { id: o.id } })">Voir</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-block d-md-none">
                <div class="mobile-client-card" v-for="(o, idx) in clientsToPrint" :key="o.id">
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <h6 class="mb-1">{{ o.label || '—' }} <span :class="'badge ' + statusInfo[o.status]?.class">
                                    {{ statusInfo[o.status]?.label || '—' }}
                                </span></h6>
                            <p class="mb-1"><small class="text-muted">#{{ idx + 1 }} • {{
                                o.status!='pending' ? dateFormater.formatDate(o.next_rdv) + ' - ' + daysUntil(o.next_rdv) : 'En attente de validation' }}</small></p>
                            <p class="mb-1"><strong>Client:</strong> {{ (o.client.nom + (' ' + o.client.prenoms) ||
                                null) ||
                                '—' }} ({{ o.client.telephone || '—' }})</p>
                        </div>
                    </div>
                    <div class="d-flex gap-2 mt-2">
                        <button class="btn btn-sm btn-outline-purple flex-fill"
                            @click="$router.push({ name: 'models.view', params: { id: o.id } })">Voir</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="alert alert-info rounded">Aucune commande trouvée. Essayez un autre filtre.</div>
    </div>
</template>

<script>

import dateFormater from '@/helpers/dateFormater';
import { modelStatusInfo } from '@/enums/ModelStatus';
import textFormater from '@/helpers/textFormater';

export default {
    name: 'ClientsList',
    data() {
        return {
            orders: [],
            search: "",
            filter: "all",
            link: "/styles",
            rdvCounts: []
        }
    },
    computed: {
        textFormater() {
            return textFormater;
        },
        rdvCountsToPrint() {
            let daysList = [];
            const today = new Date();
            for (let i = 0; i < 7; i++) {
                const day = new Date(today);
                day.setDate(today.getDate() + i);
                const dayKey = day.toISOString().split('T')[0];
                daysList.push({
                    day: dayKey,
                    dayName: textFormater.ucfirst(day.toLocaleDateString('fr-FR', { weekday: 'long' })),
                    shortDayName: day.toLocaleDateString('fr-FR', { weekday: 'short' }).charAt(0).toUpperCase()+'.',
                    count: this.rdvCounts.find(ele => ele.next_rdv === dayKey)?.count || 0
                });
            }
            return daysList;
        },
        statusInfo() {
            return modelStatusInfo;
        },
        dateFormater() {
            return dateFormater;
        },
        clientsToPrint() {

            const s = this.search.trim().toLowerCase();
            if (s.length <= 3 && this.filter === "all") {
                return this.orders;
            }

            return this.orders.filter(ele => {
                let spy = ((ele.label?.toLowerCase().includes(s) || false)
                    || (ele.client?.nom?.toLowerCase().includes(s) || false)
                    || (ele.client?.prenoms?.toLowerCase().includes(s) || false)
                    || (ele.client?.telephone?.toLowerCase().includes(s) || false)
                    || (ele.client?.telephone2?.toLowerCase().includes(s) || false));
                if (this.filter !== "all") {
                    spy = spy && ele.status === this.filter;
                }
                return spy;
            });
        }
    },
    methods: {
        getOrders() {
            this.$api.get(this.link)
                .then(response => {
                    this.orders = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the clients!', error);
                });
        },
        filterByStatus(status) {
            if (this.filter === status) {
                this.filter = "all";
                return;
            }
            this.filter = status;
        },
        getRdvCounts() {
            this.$api.get('/rendez_vouses')
                .then(response => {
                    this.rdvCounts = response.data.data;

                })
                .catch(error => {
                    console.error('There was an error fetching the rdv counts!', error);
                });
        },
        daysUntil(dateStr) {
            if (!dateStr) return null;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const target = new Date(dateStr);
            target.setHours(0, 0, 0, 0);
            const diffTime = target - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays === 0) return 'Aujourd\'hui';
            if (diffDays === 1) return 'Demain';
            if (diffDays < 0) return 'Passé';
            return `dans ${diffDays} jours`;
        }
    },
    created() {
        this.getOrders();
        this.getRdvCounts();

    }
}
</script>

<style scoped>
:root {
    --purple-dark: #4c3575;
    --purple: #6a4aa6;
    --purple-light: #c1a7e4;
    --purple-soft: #f2eafc;
}

.clients-list {
    background: linear-gradient(130deg, #f8f2ff 0%, #fff 60%);
}

.header-card {
    background-color: rgba(106, 74, 166, 0.12);
    border: 1px solid rgba(106, 74, 166, 0.3);
}

.btn-purple,
.table-purple,
.btn-outline-purple {
    color: var(--purple);
    background-color: var(--purple);
    border-color: var(--purple);
}

.btn-outline-purple {
    color: var(--purple);
    background-color: transparent;
    border-color: var(--purple);
}

.btn-outline-purple:hover,
.btn-purple:hover,
.clients-list .btn:hover {
    color: var(--purple-light);
    background-color: var(--purple-light) !important;
    border-color: var(--purple-light) !important;
}

.table-purple {
    background-color: var(--purple);
    border-color: var(--purple);
}

.clients-table {
    border: 1px solid rgba(106, 74, 166, 0.3);
    box-shadow: 0 6px 18px rgba(106, 74, 166, 0.12);
}

.table-row-hover:hover {
    background-color: var(--purple-soft);
}

.table th,
.table td {
    vertical-align: middle;
}

.mobile-client-card {
    border: 1px solid rgba(106, 74, 166, 0.3);
    border-radius: 0.6rem;
    background: #fff;
    padding: 0.85rem;
    margin-bottom: 0.9rem;
    box-shadow: 0 4px 12px rgba(106, 74, 166, 0.08);
}

.mobile-client-card h6 {
    margin: 0;
    color: #4c3575;
}

.mobile-client-card p {
    margin: 0.2rem 0;
}
</style>
